/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex, Grid, Text } from '@chakra-ui/react'
import { FaChevronDown, FaChevronUp, FaCog, FaPlayCircle, FaRegPauseCircle, FaTrash } from 'react-icons/fa'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../components/ElementoTooltipCmp'
import { iItemFeedbackResponse } from '../../../../interfaces'
import { CheckIsItemDeVisualizacao, CheckIsItemPadrao, GetDescricaoItemFeedback, GetNomeItemFeedback } from '../../../../Utils/Helper'

interface iCardProps {
  item: iItemFeedbackResponse
  quantidadeItens: number
  onRemove: (response: { ordem?: number, tipo: number }) => void
  onSubirItem: (ordem?: number) => void
  onDescerItem: (ordem?: number) => void
  onConfigurar?: (ordem?: number) => void
  onUpdate: (item: iItemFeedbackResponse) => void
  configuracaoPendente?: boolean
  iniciado: boolean
  firstItem: boolean
}

export const CardItemSelecionado: React.FC<iCardProps> = ({ item, onUpdate, quantidadeItens, onDescerItem, onSubirItem, onRemove, iniciado, onConfigurar, configuracaoPendente, firstItem }) => {
  function GetColorByStatus(): string {
    if (configuracaoPendente) return 'var(--Red)'

    return 'var(--Green2)'
  }

  function GetStatusName(): string {
    if (configuracaoPendente) return 'CONFIGURAR'

    return 'OK'
  }

  function GetItemDescricao(): string {
    if ((item.tipo === 3 || item.tipo === 4) && item.pesquisa) {
      return item.pesquisa?.nome ?? ''
    }
    if (item.tipo === 5 && item.pesquisaInterna) {
      return item.pesquisaInterna?.nome ?? ''
    }

    return GetDescricaoItemFeedback(item.tipo)
  }

  const podeDescer = !item.ordem ? false : item.ordem < quantidadeItens
  const podeSubir = !item.ordem ? false : item.ordem > 1
  return (
    <Grid gridTemplateColumns={'4rem auto 12rem'} pr={'1.5rem'} gap={'2rem'} h={'3.75rem'} border={'1px solid var(--c4)'} bg={'var(--c1)'} position={'relative'} w={'100%'} alignItems={'center'} pos={'relative'} borderTop={(item.ordem === 1 || firstItem) ? undefined : 'none'}>
      <Flex alignItems={'center'} justifyContent={'end'} pr={CheckIsItemDeVisualizacao(item.tipo) ? '1.25rem' : '.325rem'}>
        {!CheckIsItemDeVisualizacao(item.tipo) && quantidadeItens > 1 && !iniciado && <Box as='div' position={'absolute'} left={'.75rem'} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'start'}>
          <Flex h={'1.25rem'} alignItems={'center'} display={podeSubir ? 'block' : 'none'} _hover={{ color: 'var(--Azul)' }}><FaChevronUp size={14} cursor={podeSubir ? 'pointer' : undefined} onClick={() => { if (podeSubir) { onSubirItem(item.ordem) } }} /></Flex>
          <Flex h={'1.25rem'} alignItems={'center'} display={podeDescer ? 'block' : 'none'} _hover={{ color: 'var(--Azul)' }}><FaChevronDown size={14} cursor={podeDescer ? 'pointer' : undefined} onClick={() => { if (podeDescer) { onDescerItem(item.ordem) } }} /></Flex>
        </Box>}
        <Text fontWeight={700} fontSize={'14px'}>{CheckIsItemDeVisualizacao(item.tipo) ? '-' : item.ordem}</Text>
      </Flex>
      <Grid alignItems={'center'} gap={'.75rem'} gridTemplateColumns={'12rem 1fr 7rem'}>
        <Flex alignItems={'center'} w={'100%'}>
          <Text fontSize={'14px'} fontWeight={400}>{GetNomeItemFeedback(item.tipo)}</Text>
        </Flex>
        <Flex alignItems={'center'} w={'100%'}>
          <Text fontSize={'14px'} fontWeight={400}>{GetItemDescricao()}</Text>
        </Flex>
        <Flex alignItems={'center'} w={'100%'}>
          <Flex fontSize={'12px'} fontWeight={700} h={'1.75rem'} borderRadius={'.325rem'} px={'1rem'} alignItems={'center'} bg={GetColorByStatus()} color={'var(--c1)'}>{GetStatusName()}</Flex>
        </Flex>
      </Grid>
      {!CheckIsItemPadrao(item.tipo) && <Flex justifyContent={'end'} gap={'1rem'} alignItems={'center'}>
        {!CheckIsItemDeVisualizacao(item.tipo) && <ButtonCmp isDisabled={iniciado} w={'8.25rem'} VarColor='Roxo' leftIcon={<FaCog/>} small onClick={() => { if (onConfigurar) { onConfigurar(item.ordem) } }}>Configurar</ButtonCmp>}
        {CheckIsItemDeVisualizacao(item.tipo) && <Flex w={'8.25rem'} fontWeight={600} fontSize={'14px'} borderRadius={'.325rem'} alignItems={'center'} color={'var(--Azul)'}>Item de visualização</Flex>}
        {!iniciado && <ElementoTooltipCmp bg={'var(--Red)'} label={'Excluir item'}>
          <ButtonCmp small cursor={'pointer'} onClick={() => onRemove({ ordem: item.ordem, tipo: item.tipo })} alignItems={'center'} justifyContent={'center'} OutlineColor='Red'>
            <FaTrash/>
          </ButtonCmp>
        </ElementoTooltipCmp>}
      </Flex>}
      {CheckIsItemPadrao(item.tipo) && <Flex justifyContent={'end'} gap={'1rem'} alignItems={'center'}>
        <Flex justifyContent={'start'} fontWeight={600} gap={'1rem'} color={'var(--Roxo)'} fontSize={'14px'}>
          Item padrão
        </Flex>
        <ElementoTooltipCmp bg={item.desabilitado ? 'var(--Green2)' : 'var(--Red)'} label={item.desabilitado ? 'Habilitar item' : 'Desabilitar item'}>
          <ButtonCmp small cursor={'pointer'} onClick={() => onUpdate({ ...item, desabilitado: !item.desabilitado })} alignItems={'center'} justifyContent={'center'} OutlineColor={item.desabilitado ? 'Green2' : 'Red'}>
            {item.desabilitado ? <FaPlayCircle/> : <FaRegPauseCircle/>}
          </ButtonCmp>
        </ElementoTooltipCmp>
      </Flex>}
    </Grid>
  )
}
